import Reveal from '../components/Reveal';
import { Sprig } from '../components/icons';
import './Intro.css';

export default function Intro() {
  return (
    <section className="section intro">
      <div className="container intro__inner">
        <Reveal>
          <Sprig className="intro__sprig" />
          <p className="intro__lead">
            Siluets Raunā, <em>Aizrozēs</em>
          </p>
          <p className="intro__tagline">
            Vingrošana <span>●</span> Masāža <span>●</span> Labsajūta
          </p>
        </Reveal>
      </div>
    </section>
  );
}
